import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [

    {
        path: '/andchongqing/',
        name: 'index',
        component: resolve => {
            require(['@/views/andchongqing/index'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: '/andchongqing/tickets',
        name: 'tickets',
        component: resolve => {
            require(['@/views/andchongqing/tickets'], resolve);
        },
        meta: {
            title: '优惠券'
        }
    },
    {
        path: '/andchongqing/serve',
        name: 'serve',
        component: resolve => {
            require(['@/views/andchongqing/serve'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: '/andchongqing/agreement',
        name: 'agreement',
        component: resolve => {
            require(['@/views/andchongqing/agreement'], resolve);
        },
        meta: {
            title: '服务协议'
        }
    },
    {
        path: '/andchongqing/confirmOrder',
        name: 'confirmOrder',
        component: resolve => {
            require(['@/views/andchongqing/confirmOrder'], resolve);
        },
        meta: {
            title: '确认订单'
        }
    },
    {
        path: '/andchongqing/orderDetail',
        name: 'orderDetail',
        component: resolve => {
            require(['@/views/andchongqing/orderDetail'], resolve);
        },
        meta: {
            title: '订单详情'
        }
    },
    {
        path: '/andchongqing/success',
        name: 'success',
        component: resolve => {
            require(['@/views/andchongqing/success'], resolve);
        },
        meta: {
            title: '支付成功'
        }
    },
    {
        path: '/andchongqing/receiveTicket',
        name: 'receiveTicket',
        component: resolve => {
            require(['@/views/andchongqing/receiveTicket'], resolve);
        },
        meta: {
            title: '领取优惠券'
        }
    },
    {
        path: '/andchongqing/login',
        name: 'andcqLogin',
        component: resolve => {
            require(['@/views/andchongqing/login'], resolve);
        },
        meta: {
            title: '登录'
        }
    },
    {
        path: '/andchongqing/getOpenid',
        name: 'getOpenid',
        component: resolve => {
            require(['@/views/andchongqing/getOpenid'], resolve);
        },
        meta: {
            title: '泓华医疗'
        }
    },
]


let route = [{
    path: '/andchongqing',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/andcq.js